
import AppMissingModule from "@/components/common/MissingModule.vue";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			moduleId: 0,
		};
	},
	mounted() {
	},
	created() {
		this.moduleId = parseInt(this.$route.params.id) || 0;
	},
	components: {
		AppMissingModule
	},
	i18nEx: {
		componentPrefix: "views.MissingModule"
	}
});
